/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Пагинация
 * @export
 * @interface RegistryImageSearch200ResponsePagination
 */
export interface RegistryImageSearch200ResponsePagination {
  /**
   *
   * @type {number}
   * @memberof RegistryImageSearch200ResponsePagination
   */
  total?: number
  /**
   *
   * @type {number}
   * @memberof RegistryImageSearch200ResponsePagination
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof RegistryImageSearch200ResponsePagination
   */
  perPage: number
  /**
   *
   * @type {number}
   * @memberof RegistryImageSearch200ResponsePagination
   */
  lastPage: number
}

/**
 * Check if a given object implements the RegistryImageSearch200ResponsePagination interface.
 */
export function instanceOfRegistryImageSearch200ResponsePagination(
  value: object
): value is RegistryImageSearch200ResponsePagination {
  if (!('page' in value) || value['page'] === undefined) return false
  if (!('perPage' in value) || value['perPage'] === undefined) return false
  if (!('lastPage' in value) || value['lastPage'] === undefined) return false
  return true
}

export function RegistryImageSearch200ResponsePaginationFromJSON(
  json: any
): RegistryImageSearch200ResponsePagination {
  return RegistryImageSearch200ResponsePaginationFromJSONTyped(json, false)
}

export function RegistryImageSearch200ResponsePaginationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryImageSearch200ResponsePagination {
  if (json == null) {
    return json
  }
  return {
    total: json['total'] == null ? undefined : json['total'],
    page: json['page'],
    perPage: json['perPage'],
    lastPage: json['lastPage'],
  }
}

export function RegistryImageSearch200ResponsePaginationToJSON(
  value?: RegistryImageSearch200ResponsePagination | null
): any {
  if (value == null) {
    return value
  }
  return {
    total: value['total'],
    page: value['page'],
    perPage: value['perPage'],
    lastPage: value['lastPage'],
  }
}
